import { AxiosCreateAdvocate } from "Api/public/axios";
import { isEmpty as _isEmpty, forOwn as _forOwn } from "lodash";

const ADVOCATE_CREATE_PAYLOAD = "forms/advocateCreatePayload";
const ADVOCATE_RECORD = "forms/advocateRecord";

export default class AdvocateService {
  constructor(store) {
    this.store = store;
  }

  async createAdvocate(formValues, customFields, honeypotPageLoadTime) {
    const payload = this.getCreateOrUpdatePayload(
      formValues,
      customFields,
      honeypotPageLoadTime
    );

    const createAdvocateRequest = await AxiosCreateAdvocate.post("", payload);

    this.store.dispatch(ADVOCATE_RECORD, createAdvocateRequest.data);
    this.store.dispatch(ADVOCATE_CREATE_PAYLOAD, payload);

    return createAdvocateRequest;
  }

  getAddress(formValues) {
    const keys = [
      'county',
      'city',
      'state',
      'zip4',
      'lat',
      'lon'
    ];
    let advocateAddress = {
      address1: formValues.address1,
      zip5: formValues.zip5,
      // honeypot values
      zipcode: formValues.zipcode,
      address: formValues.address
    };

    keys.forEach(key => {
      if (formValues[key]) {
        advocateAddress[key] = formValues[key];
      }
    });

    if (!_isEmpty(formValues.country)) {
      advocateAddress = {
        ...advocateAddress,
        country: formValues.country
      };
    }

    return advocateAddress;
  }

  getCreateOrUpdatePayload(formValues, customFields, honeypotPageLoadTime) {
    const address = this.getAddress(formValues);

    if (_isEmpty(formValues.zipcode)) {
      address.zipcode = honeypotPageLoadTime;
    }

    const advocateParameters = {
      identifiers: {
        phone: "",
        email: ""
      },
      title: formValues.title,
      name: formValues.fullName,
      address,
      customFields: this.getStateCustomFieldsValues(customFields, formValues)
    };

    const devices = this.getDevices(formValues);

    if (_isEmpty(devices)) {
      return advocateParameters;
    }

    const emailDevice = devices.email || {};
    const phoneDevice = devices.phone || {};

    return {
      ...advocateParameters,
      identifiers: {
        phone: phoneDevice.address,
        email: emailDevice.address
      },
      devices
    };
  }

  getDevices(formValues) {
    const devices = {};
    // TODO: find a way to pull in this method from general mixin
    // const phone = this.normalizePhone(formValues.phone);
    const { email, phone } = formValues;

    if (!_isEmpty(phone)) {
      devices.phone = {
        address: phone,
        subscribed: formValues.subscribeSms || false
      };
    }

    if (!_isEmpty(email)) {
      devices.email = {
        address: email,
        subscribed: formValues.subscribeEmail || false
      };
    }

    return devices;
  }

  // eslint-disable-next-line class-methods-use-this
  getStateCustomFieldsValues(customFields, formValues) {
    const customFieldsValues = {};

    _forOwn(customFields, (fieldDetails, fieldName) => {
      const fieldValue = formValues[fieldName];
      customFieldsValues[fieldDetails.id] = fieldValue;
    });

    return customFieldsValues;
  }
}
